import { useRef, useState } from "react";
import { FaMask } from "react-icons/fa";
import { FaBars, FaGear, FaRightFromBracket, FaToolbox } from "react-icons/fa6";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/utility-hoks/useAuth";
import useOutsideClick from "../hooks/utility-hoks/useClickOutside";
import { useUserImpersonation } from "../hooks/utility-hoks/useUserImpersonation";
import rokaLogo from "../images/roka-management-logo.png";

export const ProtectedLayout = () => {
  const { user, originalUser, logout, isImpersonating } = useAuth();
  const { stopImpersonating } = useUserImpersonation();
  const navigate = useNavigate();

  const [isNavigationMenuOpen, setIsNavigationMenuOpen] =
    useState<boolean>(false);

  // clicking outside of dropdown menu should de-activate it
  const dropdownRef = useRef<HTMLDivElement>(null);
  useOutsideClick({
    ref: dropdownRef,
    handler: () => setIsNavigationMenuOpen(false),
  });

  if (!user) {
    return <Navigate to="/login" />;
  }

  const goToView = (view: string) => () => {
    setIsNavigationMenuOpen(false);
    navigate(`/${view}`);
  };

  const handleStopImpersonating = () => {
    setIsNavigationMenuOpen(false);
    stopImpersonating();
  };

  return (
    <div className="protected-layout">
      <nav>
        <img
          onClick={() => navigate("/")}
          className="roka-logo"
          src={rokaLogo}
          alt="roka-management-logo"
        />
        <div className="location-name">{`| ${user.site}`}</div>
        {isImpersonating && (
          <div className="impersonation-indicator">
            <span className="icon">
              <FaMask />
            </span>
            {user.username}
          </div>
        )}
        <div ref={dropdownRef} className="settings">
          <div
            onClick={() => setIsNavigationMenuOpen(!isNavigationMenuOpen)}
            className={`toggle-settings-button ${isNavigationMenuOpen && "active"}`}
          >
            <FaBars />
          </div>
          <div
            className={`settings-dropdown-items ${isNavigationMenuOpen && "active"}`}
          >
            {isImpersonating && (
              <div
                className="setting-item impersonate-setting"
                onClick={handleStopImpersonating}
              >
                <FaMask /> Stopp impersonering
              </div>
            )}
            <div className="setting-item" onClick={logout}>
              <FaRightFromBracket /> Logg ut
            </div>
            <div className="setting-item" onClick={goToView("settings")}>
              <FaGear /> Innstillinger
            </div>
            {originalUser.isAdmin && (
              <div className="setting-item" onClick={goToView("admin")}>
                <FaToolbox /> Admin
              </div>
            )}
          </div>
        </div>
      </nav>
      <Outlet />
    </div>
  );
};
